const ChartComponent = {
  methods: {
    redraw() {
      this.renderChart(this.chartData, this.options);
    },
  },
};
export { ChartComponent as default };
